<template>
    <div class="column box is-5-mobile is-4-tablet is-3-desktop "
         v-observe-visibility="visibilityChanged"
    v-bind:class="{'visible':isVisible}">
        <figure class="media-left">
            <p class="image is-64x64">
                <img :src="src">
            </p>
        </figure>
        <div class="media-content">
            <div class="content">
                <p>
                    <strong>{{name}}</strong><br>
                    <a :href="fixtw(twitter)">@{{twitter}}</a>
                    <br>
                    {{text}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mem",
        props:[
            'name',
            'text',
            'src',
            'twitter'
        ],
        data(){
            return{
                isVisible:false,
                twurl:""
            }
        },
        methods:{
            fixtw:function (twitter) {
                return "https://twitter.com/"+twitter
            },
            visibilityChanged (isVisible, entry) {
                this.isVisible = isVisible
                console.log(entry)
            }
        }

    }
</script>

<style scoped>
    .box{
        margin: 0.5rem;
        opacity:0.0;
        transition: 0.5s ease-in-out;
        transform: translateX(10px);
    }
    .visible{
        opacity:1.0;
        transform: translateX(0);
    }

    p{
        overflow-wrap: break-word;
        font-size: 14px;
    }
</style>